<template>
  <div>
    
    <vue-feedback-reaction
      v-model="val"
      emojiWidth="40px"
      emojiHeight="40px"
      :labels="labels"
      labelClass="feedback-labels"
      @input="onChange"
    />
    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import { VueFeedbackReaction } from "vue-feedback-reaction";
import AnswerRequiredField from "./AnswerRequiredField";
export default {
  name: "answer-emoji",
  components: {
    VueFeedbackReaction,
    AnswerRequiredField
  },
  props: {
    required: Boolean,
  },
  data() {
    return {
      isvalid: true,
      visit: "",
      val: 0,
      labels: ["", "", "", "", ""],
    };
  },
  methods: {
    value() {
      return { value: this.val };
    },
    isNegative(){
      return this.value().value < 3 && this.value().value > 0;
    },
    isValid() {
      return this.required ? (this.val > 0 ? true : false) : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange(){
      this.isvalid = true;
      this.$emit('changed', this.value());
    },
  },
};
</script>

<style lang="scss">
.feedback-labels {
  display: none;
}
.vue-reaction .animated {
  animation: none !important;
}
</style>